import React from 'react';
import { Slider } from './ui/slider';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';
import { formatPrice } from '../lib/currency';

// Pure presentational filter controls (used in desktop rail + mobile sheet).
export const FilterControls = ({ filters, setFilters, bounds, airlines, currency, onChange }) => {
  const update = (patch) => {
    const next = { ...filters, ...patch };
    setFilters(next);
    onChange?.(next);
  };
  const toggleStop = (s) => {
    const set = new Set(filters.stops);
    set.has(s) ? set.delete(s) : set.add(s);
    update({ stops: Array.from(set) });
  };
  const toggleAirline = (code) => {
    const set = new Set(filters.airlines);
    set.has(code) ? set.delete(code) : set.add(code);
    update({ airlines: Array.from(set) });
  };

  return (
    <div className="space-y-6" data-testid="filter-controls">
      <div>
        <h4 className="font-semibold text-sm mb-3">Max price</h4>
        <Slider min={bounds.priceMin} max={bounds.priceMax} step={100} value={[filters.maxPrice]}
          onValueChange={([v]) => update({ maxPrice: v })} data-testid="filter-price-slider" />
        <p className="mt-2 text-sm text-muted-foreground">Up to <span className="font-semibold text-foreground">{formatPrice(filters.maxPrice, currency)}</span></p>
      </div>

      <div>
        <h4 className="font-semibold text-sm mb-3">Stops</h4>
        <div className="space-y-2">
          {[{ v: 0, l: 'Non-stop' }, { v: 1, l: '1 stop' }, { v: 2, l: '2+ stops' }].map((s) => (
            <label key={s.v} className="flex items-center gap-2.5 cursor-pointer" data-testid={`filter-stop-${s.v}`}>
              <Checkbox checked={filters.stops.includes(s.v)} onCheckedChange={() => toggleStop(s.v)} />
              <span className="text-sm">{s.l}</span>
            </label>
          ))}
        </div>
      </div>

      <div>
        <h4 className="font-semibold text-sm mb-3">Max duration</h4>
        <Slider min={bounds.durMin} max={bounds.durMax} step={30} value={[filters.maxDuration]}
          onValueChange={([v]) => update({ maxDuration: v })} data-testid="filter-duration-slider" />
        <p className="mt-2 text-sm text-muted-foreground">Up to {Math.floor(filters.maxDuration / 60)}h {filters.maxDuration % 60}m</p>
      </div>

      <div>
        <h4 className="font-semibold text-sm mb-3">Baggage</h4>
        <label className="flex items-center gap-2.5 cursor-pointer" data-testid="filter-baggage">
          <Checkbox checked={filters.baggageOnly} onCheckedChange={(v) => update({ baggageOnly: !!v })} />
          <span className="text-sm">Checked baggage included</span>
        </label>
      </div>

      {airlines?.length > 0 && (
        <div>
          <h4 className="font-semibold text-sm mb-3">Airlines</h4>
          <div className="space-y-2 max-h-48 overflow-auto pr-1">
            {airlines.map((a) => (
              <label key={a.code} className="flex items-center gap-2.5 cursor-pointer" data-testid={`filter-airline-${a.code}`}>
                <Checkbox checked={filters.airlines.includes(a.code)} onCheckedChange={() => toggleAirline(a.code)} />
                <span className="text-sm">{a.name}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
